<template>
  <div class="w1200 pt70 pb60">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'Content'
}
</script>



// WEBPACK FOOTER //
// src/view/LayOut/content.vue